var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "interview-font", attrs: { id: "contents" } },
    [
      _c("div", { staticClass: "company-area no-top" }, [
        _vm.interview.companyName
          ? _c(
              "p",
              {
                staticClass: "company-name",
                attrs: { "data-test": "company-name" },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.interview.companyName) + "\n    "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.interview.catchCopy
          ? _c(
              "h1",
              {
                staticClass: "company-title interview-font",
                attrs: { "data-test": "catch-copy" },
              },
              [_vm._v("\n      " + _vm._s(_vm.interview.catchCopy) + "\n    ")]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.interview.image
        ? _c(
            "div",
            {
              staticClass: "contents-inner",
              attrs: { "data-test": "photo-main" },
            },
            [
              _c("div", { staticClass: "box_center" }, [
                _c("img", {
                  staticClass: "max-w100 image-height-auto",
                  attrs: {
                    src: _vm.getPhotoUrl(_vm.interview.image),
                    "data-test": "photo-main-img",
                  },
                }),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.interview.intervieweePosition
        ? _c(
            "p",
            { staticClass: "-caption", attrs: { "data-test": "position" } },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.interview.intervieweePosition) + "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.interview.intervieweeName
        ? _c(
            "p",
            {
              staticClass: "-caption fwB",
              attrs: { "data-test": "interviewee-name" },
            },
            [
              _vm._v("\n    " + _vm._s(_vm.interview.intervieweeName)),
              _c("span", [_vm._v("さん")]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.interview.intervieweeProfile
        ? _c("p", {
            staticClass: "-caption pega-pre-wrap",
            attrs: { "data-test": "profile" },
            domProps: { textContent: _vm._s(_vm.interview.intervieweeProfile) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.interview.contentList, function (content, i) {
        return [
          _c("div", { key: i, staticClass: "contents-inner" }, [
            content.title || content.image || content.photoCaption
              ? _c(
                  "div",
                  {
                    staticClass: "border_red remarks-block",
                    style:
                      "background: url(" +
                      _vm.userCommonImageUrlForSp +
                      "/bg_stripe_gray.png) repeat top left;",
                    attrs: { "data-test": "content-" + i },
                  },
                  [
                    content.title
                      ? _c("p", {
                          staticClass: "pt10 pb10 fwB pega-pre-wrap",
                          attrs: { "data-test": "title-" + i },
                          domProps: { textContent: _vm._s(content.title) },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    content.image
                      ? _c("img", {
                          staticClass: "interview-img-sub image-height-auto",
                          attrs: {
                            src: _vm.getPhotoUrl(content.image),
                            "data-test": "photo-" + i,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    content.photoCaption
                      ? _c("p", {
                          staticClass: "-caption",
                          attrs: { "data-test": "caption-" + i },
                          domProps: {
                            textContent: _vm._s(content.photoCaption),
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            content.text
              ? _c("p", {
                  staticClass: "mt10 pega-pre-wrap content-text interview-font",
                  attrs: { "data-test": "text-" + i },
                  domProps: { textContent: _vm._s(content.text) },
                })
              : _vm._e(),
          ]),
        ]
      }),
      _vm._v(" "),
      _c("user-preview-menu-sp", {
        attrs: { titles: ["募集情報", "フォトクリップ"] },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }